if (!customElements.get('region-list')) {
  customElements.define(
    'region-list',
    class RegionList extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.custom-region-btn');
        this.list = this.querySelector('.custom-region-list');
        this.overlay = this.querySelector('.country-selector__overlay');

        if (this.button && this.list) {
          this.button.addEventListener('click', (e) => {
            e.stopPropagation(); // 阻止冒泡
            this.toggleList();
          });

          // 点击外部关闭
          document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) {
              this.hideList();
            }
          });

          // 防止 overlay 阻止关闭
          if (this.overlay) {
            this.overlay.addEventListener('click', () => this.hideList());
          }
        }
      }

      toggleList() {
        const isHidden = this.list.hasAttribute('hidden');
        this.list.toggleAttribute('hidden');
        this.button.setAttribute('aria-expanded', String(isHidden));
      }

      hideList() {
        if (!this.list.hasAttribute('hidden')) {
          this.list.setAttribute('hidden', '');
          this.button.setAttribute('aria-expanded', 'false');
        }
      }
    }
  );
}


/*
document.addEventListener("DOMContentLoaded", function () {

  const button = document.querySelector(".custom-region .custom-region-btn");
  const listWrapper = document.querySelector(".custom-region .custom-region-list");
  
  function toggleList() {
    const isHidden = listWrapper.hasAttribute("hidden");
    if (isHidden) {
      listWrapper.removeAttribute("hidden");
      button.setAttribute("aria-expanded", "true");
    } else {
      listWrapper.setAttribute("hidden", "");
      button.setAttribute("aria-expanded", "false");
    }
  }
  
  // 切换显示状态
  button.addEventListener("click", function (e) {
    e.stopPropagation(); // 防止冒泡到 window
    console.log("click")
    toggleList();
  });
  
  // 点击页面其他区域关闭下拉列表
  window.addEventListener("click", function (e) {
    const isClickInside = button.contains(e.target) || listWrapper.contains(e.target);
    if (!isClickInside) {
      listWrapper.setAttribute("hidden", "");
      button.setAttribute("aria-expanded", "false");
    }
  });
});
*/